import React, { useState } from "react";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { QuotationFormHeader } from "./QuotationForm";
import {
  StyledDatagrid,
  useDataGridStyles,
} from "../../../../../../styles/DatagridStyles";
import { useNavigate } from "react-router-dom";
import Accepted from "../../../../../../images/ApprovedStatus.svg";
import Rejected from "../../../../../../images/RejectedStatus.svg";
import {
  GridAlignment,
  GridCellParams,
  GridColDef,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { LabelProps, TableHeaderProps } from "../../../../../../utils/types";
import { Label } from "../../../../../../stories/Label/Label";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import Input from "../../../../../../stories/Input/Input";
import { TABLE_ROW_HEIGHT } from "../../../../../../styles/Variables";
import { Button } from "../../../../../../stories/Button/Button";
import Download from "../../../../../../images/DownloadImage.svg";
import { Tab, Tabs } from "@mui/material";
import { a11yProps, TabPanel } from "../../../../../../styles/Tabs";
import SupplierTerms from "./SupplierTerms";
import { PageFor } from "../../../../../../utils/Enum.types";
import Confirmation from "./Confirmation";
import { WaiveOffModalStyles } from "../../../../../../styles/CustomModalStyles";
import Modal from "react-modal";
import useFormJson from "../../../../../../json/useFormJson";

const Data = [
  {
    desc: "CCTV",
    required_qty: 0,
    terms: "urgently required",
    payment_terms: "-",
    intersted: "yes",
    change_in_desc: "yes",
    specify_change: "-",
    quoted_qty: 0,
    rate: 0,
    charges_per_qty: "no",
    tax: 0,
    total_amount: 0,
    delivery_charges: 0,
    installation_charges: 0,
    net_quoted: 0,
    remaks: "",
    file: "sample.doc",
  },
];
const ReviewQuotation = () => {
  const { Purchase } = useAssetTableJson();
  const { headerStyles } = useDataGridStyles();
  const navigate = useNavigate();
  const [confirmation, setConfirmation] = useState(false);
  const {Quotation}=useFormJson();
  const [value, setValue] = useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const renderCellBasedOnValue = (params: GridCellParams) => {
    if (params.value === "yes") {
      return (
        <img
          src={Accepted}
          alt="Accepted"
          className="view-pending__tableblock--pending"
        />
      );
    } else if (params.value === "no") {
      return (
        <img
          src={Rejected}
          alt="Rejected"
          className="view-pending__tableblock--pending"
        />
      );
    }
    return <span>-</span>;
  };
  const dynamicHeaders: TableHeaderProps[] =
    Purchase.Quotation.Login.FillForm.filter(
      (header: TableHeaderProps) => header.field !== "actions"
    ).map((header) => {
      const dynamicHeader: TableHeaderProps = {
        headerName: header.headerName,
        field: header.field,
        headerAlign: header.headerAlign as GridAlignment,
        align: header.align as GridAlignment,
        flex: header.flex,
        cellClassName: header.cellClassName,
        hideable:header.hideable
      };

      const fieldsWithCustomRender = [
        "interested_to_quote",
        "if_any_change_in_desc",
        "any_other_charges_per_qty",
      ];

      if (fieldsWithCustomRender.includes(header.field)) {
        dynamicHeader.renderCell = renderCellBasedOnValue;
      } else if (header.field === "upload_product_details") {
        dynamicHeader.renderCell = (params: GridCellParams) => (
          <div className="quotation-form__block--file">
            {/* <img src={getFileIcon(params.row.upload_product_details)} alt="" /> */}
            {params.row.upload_product_details}
            <img src={Download} alt="" />
          </div>
        );
      }
      return dynamicHeader;
    });
  const columns: GridColDef[] = [...dynamicHeaders];

  const rows: GridValidRowModel[] =
    (Data || []).map((data, index) => {
      return {
        id: index + 1,
        item_desc: data.desc,
        required_qty: data.required_qty,
        terms: data.terms,
        payment_terms: data.payment_terms,
        interested_to_quote: data.intersted,
        if_any_change_in_desc: data.change_in_desc,
        if_any_change_in_desc_specify: data.specify_change,
        quoted_qty: data.quoted_qty,
        rate: data.rate,
        any_other_charges_per_qty: data.charges_per_qty,
        tax_perc: data.tax,
        total_amount: data.total_amount,
        delivery_charges: data.delivery_charges,
        installation_charges: data.installation_charges,
        net_quoted: data.net_quoted,
        remarks: data.remaks,
        upload_product_details: data.file,
        rfq_date: 0,
      };
    }) || [];

  const getRow = () => {
    if (Data.length) {
      return [
        {
          id: [],
          item_desc: [],
          required_qty: [],
          terms: [],
          payment_terms: [],
          interested_to_quote: [],
          if_any_change_in_desc: [],
          if_any_change_in_desc_specify: [],
          quoted_qty: [],
          rate: [],
          any_other_charges_per_qty: [],
          tax_perc: "Total",
          total_amount: 0,
          delivery_charges: 0,
          installation_charges: 0,
          net_quoted: 0,

          remarks: [],
          upload_product_details: [],
        },
      ];
    }
    return [];
  };

  const pinnedRows = {
    bottom: getRow(),
  };

  const getCellClassName = (params: GridCellParams) => {
    const pinnedRowIds = pinnedRows.bottom
      ? pinnedRows.bottom.map((row) => row.id)
      : [];

    const isPinnedRow = pinnedRowIds.includes(params.row.id);

    if (isPinnedRow) {
      switch (params.field) {
        case "total_amount":
        case "delivery_charges":
        case "installation_charges":
        case "net_quoted":
          return "total-count";

        case "tax_perc":
          return "total";
        default:
          return "hide-td";
      }
    }

    return "";
  };
  return (
    <div className="review-quotation">
      <div className="review-quotation__block">
        <div className="review-quotation__block--header">
          <b>Review and Submit Quotation Details</b>
        </div>

        <div className="quotation-preview__block--filters">
          {[0, 1, 2].map((colIndex) => (
            <div key={colIndex}>
              {Quotation.Preview.slice(
                colIndex * 3,
                colIndex === 2 ? 7 : (colIndex + 1) * 3
              ).map((label: LabelProps) => (
                <div className="quotation-preview__block--filters--grid">
                  <Label>{label.labelName}</Label>
                  {label.dataType === "textarea" ? (
                    <TextArea rows={3} disabled />
                  ) : (
                    <Input disabled type={label.dataType} />
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="review-quotation__block--tabs row g-0">
          <Tabs value={value} onChange={handleChange}>
            <Tab label="Quotation Details" value={0} {...a11yProps(0)} />

            <Tab label="Terms and Conditions" value={1} {...a11yProps(1)} />
          </Tabs>
        </div>

        <div className="review-quotation__block--tabpanel">
          <TabPanel value={value} index={0}>
            <StyledDatagrid
              columns={columns}
              rows={rows}
              rowHeight={TABLE_ROW_HEIGHT}
              // onCellClick={(params) => {
              //   if (params.field === "prefered_vendor") {
              //     setSelectedSuppliers(!selectedSuppliers);
              //   }
              // }}
              sx={{
                ...headerStyles,
              }}
              disableRowSelectionOnClick
              hideFooter
              pinnedRows={pinnedRows}
              getCellClassName={getCellClassName}
              initialState={{
                pinnedColumns: {
                  left: [
                    "id",
                    "item_desc",
                    "required_qty",
                    "terms",
                    "payment_terms",
                  ],
                },
              }}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <SupplierTerms step={2} pageType={PageFor.MODAL} />
          </TabPanel>
        </div>
        <div className="review-quotation__block--buttons">
          <Button
            mode="finalize"
            onClick={() => setConfirmation(!confirmation)}
          />
          <Button mode="back" onClick={() => navigate(-1)} />
        </div>
      </div>

      <Modal
        isOpen={confirmation}
        style={WaiveOffModalStyles}
        ariaHideApp={false}
      >
        <Confirmation setModalFlag={setConfirmation} />
      </Modal>
    </div>
  );
};

export default ReviewQuotation;
